import { render, staticRenderFns } from "./GastroPreviewBowelCleanseForms.vue?vue&type=template&id=3566536a&"
import script from "./GastroPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
export * from "./GastroPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
import style0 from "./GastroPreviewBowelCleanseForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports